<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        <v-flex>
          <v-layout>
            <v-flex xs4>
              <!-- <div class="subtitle-2 mb-1">Select Region</div> -->
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regionsWithAll"
                v-model="selectedRegion"
                item-text="name"
                placeholder="Select Region"
                @change="selectRegion"
              >
              </v-select>
            </v-flex>

            <v-flex text-right>
              <v-btn @click="refresh" depressed color="primary">
                Refresh
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="chatStreamItems"
        :items-per-page="30"
        class="elevation-0"
        :search="search"
        no-data-text="No data available"
      >
        <template v-slot:item.actions="{ item }">
          <div style="min-width: 50px">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small class="mr-2" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </div>

          
        </template>
       
        <template v-slot:item.content.attachment="{ item }">
          <div style="min-width: 50px">
            <v-icon
              small
              v-if="
                item.content.attachment ? item.content.attachment !== '' : false
              "
            >
              mdi-paperclip
            </v-icon>
          </div>
        </template>
        <template v-slot:item.state="{ item }">
          <div style="min-width: 80px">
            {{ item.state }}
          </div>
        </template>
        <template v-slot:item.content.text="{ item }">
          <div class="text">
            {{ item.content.text }}
          </div>
         
        </template>
        <template v-slot:item.region.name="{ item }">
          <div style="min-width: 100px">
            {{ item.region.name }}
          </div>
        </template>
        <template v-slot:item.from="{ item }">
          <div style="min-width: 90px">
            {{ item.from[0] }}
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <div style="min-width: 100px">
            {{ iMoment(item.createdAt) }}
          </div>
        </template>
      </v-data-table>
    </v-card>
    <edit-chat-stream-dialog
      :selectedRegion="selectedRegion"
      :pinDetail="editedItem"
      :collection="collection"
      ref="editChatStreamDialog"
    />
    <v-dialog v-model="dialogDelete" width="300">
      <v-card>
        <v-card-title>Are you sure you want to delete this item?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="error"
            class="text-none subtitle-2"
            @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-none subtitle-2"
            text
            @click="deleteItemConfirm"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EditChatStreamDialog from "../components/EditChatStreamDialog.vue";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
  components: { EditChatStreamDialog },
  data() {
    return {
      selectedRegion: {},
      collection: "pipeline",

      search: "",
      dialogDelete: false,
      itemToDelete: {
        scheduledAt: "",
        state: "",

        data: {
          expiresAt: "",
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
      headers: [
        {
          text: "Content",
          align: "start",
          sortable: true,
          value: "content.text",
        },
        { text: "Attch", value: "content.attachment" },
        // { text: "Font Name", value: "fontName" },

        { text: "Region", value: "region.name" },
        { text: "From", value: "from" },
        { text: "State", value: "state" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedItem: {
        scheduledAt: "",
        state: "",
        data: {
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
      editedIndex: -1,
      defaultItem: {
        scheduledAt: "",
        state: "",
        data: {
          content: "",
          graphics: {
            entity: "",
            icon: {
              bgColor: "",
              color: "",
              name: "",
              type: "",
            },
          },
          image: {
            thumbnail: "",
            url: "",
          },
          isMarker: "",
          location: "",
          score: "",

          totalComments: "",
          type: "",
          views: "",
        },
      },
    };
  },
  computed: {
    ...mapState("$_content", ["chatStreamItems"]),
    ...mapState("$_home", ["regions"]),
    regionsWithAll() {
      var arr = [];
      arr.push({ name: "All" });
      arr = arr.concat(this.regions);
      return arr;
    },
  },
  created() {
    this.getStream({collection: "crawlerstream"});
    if (this.regions.length === 0) {
      this.getRegions({ collection: "regions", mutation: "updateRegions" });
    }
  },
  methods: {
    ...mapActions({
      getStream: "$_content/getStream",
      getStreamByRegion: "$_content/getStreamByRegion",
      deleteStreamItem: "$_content/deleteStreamItem",
      getRegions: "$_home/getContent",
    }),
    refresh() {
      if (this.selectedRegion.name == null ) {
        this.getStream({collection: "crawlerstream"});
      } else if (this.selectedRegion.name == "All") {
        this.getStream({collection: "crawlerstream"});
      } else {
        this.getStreamByRegion({collection: "crawlerstream", region: this.selectedRegion});
      } 
      
    },
    selectRegion() {
      console.log("selectedRegion: ", this.selectedRegion);
      if (this.selectedRegion.name !== "All") {
        this.getStreamByRegion({collection: "crawlerstream", region: this.selectedRegion});
      } else {
        this.getStream({collection: "crawlerstream"});
      }
     

    },

    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    // openNewDataStreamDialog() {
    //   this.$refs.newDataStreamDialog.toggleDialog();
    // },
    editItem(item) {
      this.editedIndex = this.chatStreamItems.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.chatStreamItems[this.editedIndex]
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editChatStreamDialog.toggleDialog(this.editedItem);
    },
    searchArr(latitude, longitude, myArray) {
      for (var i = 0; i < myArray.length; i++) {
        if (
          myArray[i].latitude === latitude &&
          myArray[i].longitude === longitude
        ) {
          return myArray[i].name;
        }
      }
    },
    copyItem(item) {
      this.editedIndex = this.chatStreamItems.indexOf(item);
      this.editedItem = {};
      this.editedItem = Object.assign(
        {},
        this.chatStreamItems[this.editedIndex]
      );

      // console.log("Edited Item: ", this.editedItem);

      this.$refs.editChatStreamDialog.toggleDialog(this.editedItem, "copy");
    },
    deleteItem(item) {
      this.editedIndex = this.chatStreamItems.indexOf(item);
      this.itemToDelete = Object.assign(
        {},
        this.chatStreamItems[this.editedIndex]
      );
      this.itemToDelete.state = "deleted";
      this.dialogDelete = true;

      // console.log(item);
    },
    deleteItemConfirm() {
      // console.log("Deleting Item: ", this.itemToDelete);

      this.deleteStreamItem({
        details: this.itemToDelete,
        collection: "crawlerstream"
      }).then(() => {
        this.dialogDelete = false;
        this.getStream({collection: "crawlerstream"});
      });
    },
  },
};
</script>

<style>
.text {
   overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 2; /* number of lines to show */
   -webkit-box-orient: vertical;
}
</style>